import DatePicker from 'components/form/DatePicker';
import DateTimePicker from 'components/form/DateTimePicker';
import TextInput from 'components/form/TextInput';
import React from 'react';
// Agenda Page and Slot Allotment notification

const SixthStepOfFollowUps = ({ props, isEdit, suggestionData }) => {
  // const { handleChange, values } = props;
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } =
  props;
  const {
    client_name,
    conference_short_name,
    venue_name,
    address,
    map_link,
    zoom_link,
    registration_date_time,
    conference_location,
    hall_ticket_link,
    your_name,
    contact_details,
  } = values;

  return (
    <>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Client Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="client_name"
            onChange={handleChange}
            value={client_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.client_name && errors.client_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference Short Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_short_name"
            onChange={handleChange}
            value={conference_short_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.conference_short_name && errors.conference_short_name}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Venue Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="venue_name"
            onChange={handleChange}
            value={venue_name}
            disabled={!isEdit}
            suggestions={suggestionData?.venue_name}
            onBlur={handleBlur}
            error={touched.venue_name && errors.venue_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">Address</div>
        <div className="col-lg-6">
          <TextInput
            id="address"
            onChange={handleChange}
            value={address}
            disabled={!isEdit}
            suggestions={suggestionData?.address}
            onBlur={handleBlur}
            error={touched.address && errors.address}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Google Maps Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="map_link"
            onChange={handleChange}
            value={map_link}
            disabled={!isEdit}
            suggestions={suggestionData?.map_link}
            onBlur={handleBlur}
            error={touched.map_link && errors.map_link}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Access Zoom Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="zoom_link"
            onChange={handleChange}
            value={zoom_link}
            disabled={!isEdit}
            suggestions={suggestionData?.zoom_link}
            onBlur={handleBlur}
            error={touched.zoom_link && errors.zoom_link}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Registration Date and Time
        </div>
        <div className="col-lg-6">
          <DateTimePicker
            id="registration_date_time"
            onChange={handleChange}
            value={registration_date_time}
            disabled={!isEdit}
            error={errors.registration_date_time}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          location
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_location"
            onChange={handleChange}
            value={conference_location}
            disabled={!isEdit}
            suggestions={suggestionData?.conference_location}
            onBlur={handleBlur}
            error={touched.conference_location && errors.conference_location}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Hall Ticket/Zoom Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="hall_ticket_link"
            onChange={handleChange}
            value={hall_ticket_link}
            disabled={!isEdit}
            suggestions={suggestionData?.hall_ticket_link}
            onBlur={handleBlur}
            error={touched.hall_ticket_link && errors.hall_ticket_link}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_name"
            onChange={handleChange}
            value={your_name}
            disabled={!isEdit}
            suggestions={suggestionData?.your_name}
            onBlur={handleBlur}
            error={touched.your_name && errors.your_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Contact Details
        </div>
        <div className="col-lg-6">
          <TextInput
            id="contact_details"
            onChange={handleChange}
            value={contact_details}
            disabled={!isEdit}
            suggestions={suggestionData?.contact_details}
            onBlur={handleBlur}
            error={touched.contact_details && errors.contact_details}
          />
        </div>
      </div>
    </>
  );
};

export default SixthStepOfFollowUps;
